//some apis recieve only english numbers so we convert the farsi number to english
function persianToEnglishNumbers(persianNumber : any) {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  
    if(persianNumber) return persianNumber
      .split("")
      .map((char : any) => (persianNumbers.includes(char) ? englishNumbers[persianNumbers.indexOf(char)] : char))
      .join("");
}

export default persianToEnglishNumbers;